import { Input, Component as NgComponent, ViewEncapsulation, OnInit, OnChanges, ViewChild, ElementRef, Output, SimpleChanges } from '@angular/core';
import ReactDOM from 'react-dom'
import React, { Component as ReactComponent } from 'react';
import moment, { Moment } from 'moment';
import { FormControl } from '@angular/forms';
import { DayPickerSingleDateController } from 'react-dates';
import { convert, LocalDate, nativeJs, DateTimeFormatter } from 'js-joda';
import 'react-dates/initialize';
import { EventEmitter } from '@angular/core';
import { miniMoize } from '../utils';
import classNames from 'classnames'

@NgComponent({
    selector: 'sbw-datepicker2',
    template: '<div #react></div>',
    styleUrls: ['./datepicker2.component.css', './datepicker2.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class Datepicker2Component implements OnInit, OnChanges {

    hasInit = false
    @ViewChild('react', { static: true }) react: ElementRef

    @Input() icon: string
    @Input() label: string
    @Input() dateControl: FormControl
    @Input() dates: ILegDates
    @Input() h2Label: string
    @Input() infoLabel: string
    @Input() infoLegendClass: string
    @Output() openChanged = new EventEmitter<boolean>();

    constructor() {
    }

    handleDateChange = date => {
        if (this.dateControl) this.dateControl.setValue(LocalDate.from(nativeJs(date)))
    };

    ngOnInit() {
        this.hasInit = true
        this.dateControl.valueChanges.subscribe(() => this.render())
        this.dateControl.statusChanges.subscribe(() => this.render())
        this.render();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.hasInit) this.render()
    }

    private render() {
        ReactDOM.render(<Datepicker
            date={tryConvertToMoment(this.dateControl.value)}
            onDateChange={this.handleDateChange}
            dates={toDateLeg(this.dates, this.dateControl.value)}
            valid={!(this.dateControl && !this.dateControl.valid && this.dateControl.enabled)}
            disabled={this.dateControl.status == "DISABLED"}
            h2Label={this.h2Label}
            infoLabel={this.infoLabel}
            infoLegendClass={this.infoLegendClass}
            resources={{ "icon": this.icon, "label": this.label }}
            openChanged={this.openChanged}
        >
        </Datepicker>, this.react.nativeElement);
    }
}

function tryConvertToMoment(from: LocalDate): Moment {
    return from && moment(convert(from).toDate())
}

export class Datepicker extends ReactComponent<Props, State> {

    private img: any
    private div: any

    constructor(props: Props) {
        super(props)

        this.state = {
            date: toMoment(this.props.dates.initial),
            showCalendar: false,
            numberOfMonths: 1,
            size: 48,
            mobileState: false
        }
    }

    //Using moment to iterate lists is too slow(on android)
    disabledDates = miniMoize((disabledDates: string[]) => buildMap(disabledDates))
    offerDates = miniMoize((offerdates: string[]) => buildMap(offerdates))

    onOutsideClick = (event) => {
        if (event.target == this.div || event.target == this.img) return
        this.closeCalendar()
    };

    private attachMediaQueryHandler() {
        if (window.matchMedia) {
            const mqMobile = window.matchMedia('(max-width: 64em)')
            mqMobile.addListener(mq => this.widthChangeToMobile(mq))
            this.widthChangeToMobile(mqMobile);
        }
    }

    private widthChangeToMobile(mq) {
        this.setState({ mobileState: mq.matches, numberOfMonths: mq.matches ? 12 : 1, size: mq.matches ? 40 : 48 })
    }

    componentWillMount() {
        this.attachMediaQueryHandler()
    }

    arrowControl() {
        let event = this.state.showCalendar
        this.props.openChanged.emit(event)
    }

    onDateChange = (date: Moment) => {
        this.props.onDateChange(date)
        this.closeCalendar()
        this.setState(() => ({ date }))
    }

    componentDidUpdate() {
        if (this.props.date != this.state.date) {
            this.setState({ date: this.props.date })
        }
    }

    handleCalenderClick = (evt) => {
        this.setState(prev => ({ showCalendar: !prev.showCalendar }))
    }

    closeCalendar = () => {
        this.setState({ showCalendar: false })
    }

    singleDateFocusChange = () => {
        // What should happen here?, we need it as it is a required field
    };

    allowNextMonth() {
        let initialDate = moment()
        let monthDiff = moment(this.props.dates.max).diff(moment(initialDate), 'months', true)
        if (monthDiff < 12) { return false }
        return true
    }

    isDayBlocked = (date: Moment) => {
        let disabled = this.disabledDates(this.props.dates.disabled)
        let dateN = getKeyStr(date)
        let d = this.props.dates
        let min = this.props.dates.min
        if (disabled[dateN]) return true
        if (min && dateN < min) return true
        if (d.max && dateN > d.max) return true
        return false;
    };

    initialMonth = () => {
        if (!this.state.date) { return moment() }
        return this.state.mobileState ? moment() : this.state.date;
    }

    isOfferValid = (date: Moment) => {
        let offers = this.offerDates(this.props.dates.offer)
        return offers[getKeyStr(date)]
    }

    getNext() {
        if (this.state.mobileState) {
            return this.allowNextMonth() ? <img className="chevron_down" src="/_ng/booking/assets/chevron_right.svg" /> : <span></span>
        }
        return <img className="chevron_right" src="/_ng/booking/assets/chevron_right.svg" />
    }

    renderInfoLegend = () =>
    {
        if (!this.props.infoLegendClass)
            return null

        return (<span className={this.props.infoLegendClass}></span>)
    }

    renderCalendarInfo = () =>
    {
        if (!this.props.infoLabel)
            return null

        return (<div className="dateRangePickerInfo">
                    {this.renderInfoLegend()}
                    <p className="dateRangePickerInfo__info">{this.props.infoLabel}</p>
                </div>)
    }

    render() {
        this.arrowControl()
        const sharedCustomProps = {
            numberOfMonths: this.state.numberOfMonths,
            hideKeyboardShortcutsPanel: true,
            navPrev: <img className="chevron_left" src="/_ng/booking/assets/chevron_right.svg" />,
            navNext: this.getNext(),
            weekDayFormat: "ddd",
            daySize: this.state.size,
            initialVisibleMonth: this.initialMonth,
        };

        const activeClass = this.state.showCalendar ? ' dateSinglePickerWrapper--active' : '';
        this.state.mobileState && this.state.showCalendar ? document.body.style.overflowY = "hidden" : document.body.style.overflowY = "scroll"
        return (
            <div ref={r => this.div = r} className={`dateSinglePickerWrapper${activeClass}`}>
                {this.state.mobileState && this.state.showCalendar &&
                    <div>
                        <h2 className="dateSinglePickerWrapper__title">{this.props.h2Label}</h2>
                        <span className="dateSinglePickerWrapper__close" onClick={this.closeCalendar}>
                            <img className="" src="/_ng/booking/assets/close.svg" />
                        </span>
                    </div>
                }
                <div className={classNames({
                        'datepicker-container': true,
                        'datepicker-open': this.state.showCalendar })}>
                    <div ref={r => this.div = r} className={"dateInputs dateInputs__oneWay " +
                        (this.props.disabled ? 'dateInputs__disabled' : '') +
                        (!this.props.valid ? 'dateInputs__errorBorder' : '') +
                        (this.state.showCalendar ? 'dateInputs__focus' : '')} onClick={this.handleCalenderClick}>
                        <label className="dateInputs__label">{this.props.resources.label}</label>
                        <img ref={r => this.img = r} className="dateInputs__icon" src={this.props.resources.icon} />
                        <input
                            className="dateInputs__input"
                            type="text"
                            name="departure date"
                            value={this.state.date ? this.state.date.format('ddd DD/MM') : ''}
                            readOnly={true}
                            disabled={this.props.disabled}
                        />
                    </div>
                </div>
                {this.state.showCalendar &&
                    <div className="">
                        <DayPickerSingleDateController
                            // Required props
                            onDateChange={this.onDateChange}
                            onFocusChange={this.singleDateFocusChange}
                            focused={true}
                            date={this.state.date}
                            monthFormat="MMMM YYYY"
                            dayAriaLabelFormat="YYYY-MM-DD"
                            // Custom probs
                            transitionDuration={100}
                            isDayBlocked={e => this.isDayBlocked(e)}
                            onOutsideClick={this.onOutsideClick}
                            isDayHighlighted={e => this.isOfferValid(e)}
                            orientation={this.state.mobileState ? "verticalScrollable" : "horizontal"}
                            renderCalendarInfo={this.renderCalendarInfo}
                            {...sharedCustomProps}
                        />
                    </div>
                }
            </div>
        )
    }
}

export interface Props {
    date: Moment
    disabled?: boolean
    valid: boolean
    onDateChange: (d: Moment) => void
    format?: string
    h2Label: string
    infoLabel: string
    infoLegendClass: string
    dates: DateLeg
    resources: ResourcesLeg
    openChanged: EventEmitter<boolean>
}

interface State {
    numberOfMonths: number
    date: Moment
    showCalendar: boolean
    size: number
    mobileState: boolean
}

interface DateLeg {
    initial: string
    max: string
    min: string
    disabled: string[]
    offer: string[]
}

interface ILegDates {
    disabled: LocalDate[]
    min: LocalDate
    max: LocalDate
    offer: LocalDate[]
}

interface ResourcesLeg {
    icon: string
    label: string
}

function toMoment(n: string): Moment {
    return n && moment(n, 'YYYY-MM-DD')
}

function getLocalDateStr(from: LocalDate): string {
    return from && from.format(DateTimeFormatter.ISO_LOCAL_DATE)
}

function toDateLeg(from: ILegDates, initial: LocalDate): DateLeg {
    return {
        initial: getLocalDateStr(initial),
        max: getLocalDateStr(from.max),
        min: getLocalDateStr(from.min),
        disabled: from.disabled && from.disabled.map(d => getLocalDateStr(d)),
        offer: from.offer && from.offer.map(k => getLocalDateStr(k))
    }
}

function getKeyStr(m: Moment): string {
    return m && m.format('YYYY-MM-DD')
}

function buildMap(dates: string[]) {
    const map = {}
    for (let d of dates) map[d] = 1
    return map
}
